// @flow
import is from './is'
import maybeForEach from './maybeForEach'

/**
 * Iterate over array and all sub-arrays deeply. Execute
 * given function with every item.
 * @param  {Array<any>} subject
 * @param  {Function} iterator
 */
function deepForEach<T>(
  subject: ?Array<T> | T,
  iterator: (item: T, index: number) => any
) {
  maybeForEach(subject, (v) => {
    if (is.array(v)) {
      deepForEach(v, iterator)
    } else {
      iterator(v, -1)
    }
  })
}

export default deepForEach
